export default __webpack_public_path__ + "static/media/vlada_rs.5da5717f.png";